<div *ngIf="isOpen"
    class="modal-backdrop fixed inset-0 bg-slate-900/50 backdrop-blur-[2px] flex items-center justify-center p-4 overflow-y-auto"
    [style.z-index]="zIndex"
    (click)="onBackdropClick($event)">
    <div class="bg-bg rounded shadow-xl w-full font-fira-condensed flex flex-col my-auto" [ngClass]="maxWidth"
        [style.min-height]="minHeight" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="flex items-center justify-between px-4 py-4 border-b border-white/20 bg-primary shrink-0 rounded-t">
            <div class="flex items-center gap-3 min-h-[1.5rem]">
                <ng-content select="[header-start]"></ng-content>
                <h3 *ngIf="modalTitle" class="text-lg font-semibold text-white tracking-tight">{{ modalTitle }}</h3>
            </div>
            <div class="flex items-center gap-3 child-buttons-white">
                <ng-content select="[header-actions]"></ng-content>
                <button *ngIf="!hideCloseButton" (click)="onClose()" class="p-2 text-white/80 hover:text-white rounded transition-colors" title="Close">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <!-- Content (Body) -->
        <div class="bg-slate-100/50 p-6 flex-1 flex flex-col rounded-b">
            <ng-content></ng-content>
        </div>
    </div>
</div>